// JavaScript Document

// Scripts written by Jacob Bearce @ Weblinx, Inc.

const SEARCH_TOGGLE   = document.querySelector("[data-toggle=toggle-search]");
const SEARCH_FORM     = document.querySelector("#toggle-search");
const SEARCH_INPUT    = SEARCH_FORM ? SEARCH_FORM.querySelector("input[type=search]") : false;
const SEARCH_ELEMENTS = SEARCH_FORM ? SEARCH_FORM.querySelectorAll("*") : false;

if (SEARCH_TOGGLE && SEARCH_FORM && SEARCH_INPUT && SEARCH_ELEMENTS) {
    SEARCH_TOGGLE.addEventListener("click", (e) => {
        e.preventDefault();

        document.documentElement.classList.add("search-active");
        SEARCH_FORM.classList.add("is-active");
        SEARCH_INPUT.focus();
    });

    SEARCH_ELEMENTS.forEach((element) => {
        element.addEventListener("blur", () => {
            setTimeout(() => {
                if (!SEARCH_FORM.contains(document.activeElement)) {
                    document.documentElement.classList.remove("search-active");
                    SEARCH_FORM.classList.remove("is-active");
                    SEARCH_TOGGLE.focus();
                }
            }, 100);
        }, { passive: true });
    });
}
